import { FC, useMemo } from "react";

import { BAND_PATHS } from "Bands/router";
import { IEvent } from "Bands/types";
import { getEventBandId, getEventTypeIcon } from "Bands/utils";
import { Checkmark, Close } from "shared/assets/icons";
import { CalendarListDate, FancyLink, Loader } from "shared/components";
import { FlexContainer, Icon, MutedDarkText } from "shared/styles";
import { colors } from "shared/styles/constants";
import { buildUrl } from "shared/utils";

type PartialEvent = Pick<
  IEvent,
  "id" | "title" | "type" | "date" | "band" | "bandName"
>;

interface CalendarListTitleProps extends PartialEvent {
  showBand?: boolean;
  showAsSpan?: boolean;
  isCompleted?: boolean;
  isLoading?: boolean;
  isFailed?: boolean;
  showFullDate?: boolean;
}

export const CalendarListTitle: FC<CalendarListTitleProps> = ({
  id,
  title,
  type,
  date,
  band,
  bandName,
  showBand,
  showAsSpan,
  isCompleted,
  isLoading,
  isFailed,
  showFullDate,
}) => {
  const bandId = useMemo(() => getEventBandId({ band }), [band]);

  return (
    <FlexContainer size="xs" flexWrap="nowrap">
      <CalendarListDate date={date} showFullDate={showFullDate} />
      <Icon size="m" as={getEventTypeIcon(type)} color={colors.grey4} />
      {showAsSpan ? (
        <span
          style={isLoading || isCompleted || isFailed ? { flexGrow: 1 } : {}}
        >
          {title}
        </span>
      ) : (
        <FancyLink
          to={buildUrl(BAND_PATHS.BAND_EVENT, {
            bandId,
            eventId: id,
          })}
        >
          {title}
        </FancyLink>
      )}
      {showBand && bandName && <MutedDarkText>{bandName}</MutedDarkText>}
      {isLoading ? (
        <Loader size="s" />
      ) : isCompleted ? (
        <Icon as={Checkmark} color={colors.green} />
      ) : isFailed ? (
        <Icon as={Close} color={colors.red} />
      ) : null}
    </FlexContainer>
  );
};
